import React from "react";

import VideosSection from "../../components/VideoSection/VideoSection";
import { testerVideos } from "../../helpers/videos";

export default function HowToTesters() {
  return <VideosSection videos={testerVideos} />;
}
